<success-screen bgImage="coinsFiat" class="bp-modal mod-lg">
  <bp-modal-header
    header
    [title]="(isSendFiat ? 'send' : fiatTransaction?.getType()) + '_success' | translate: [fiat.getName()]">
    <a (click)="close()" right (keydown.enter)="close()" [tabIndex]="0">{{ "close" | translate }}</a>
  </bp-modal-header>
  <div content>
    <div class="success-content-inner">
      <div class="success-symbol mod-green mb-20 mt-70">
        <span class="bpi__icon-check large-weight"></span>
      </div>
      <div class="success-headline mb-15">
        {{ (isSendFiat ? "send_fiat" : fiatTransaction?.getType()) + "_successful" | translate }}
      </div>
      <p class="text-center mb-15 font-size-17">
        <span>
          {{ "your_success_screen" | translate }}
          <strong>
            {{
            fiatTransaction?.getAmount()
            | fiat_precision_symbol
            : { id: fiatTransaction?.getFiatId(), currencies: [fiat], symbol: true }
            }}
          </strong>
          {{ (isSendFiat ? "send_fiat" : fiatTransaction?.getType()) + "_success_text" | translate }}
        </span>
      </p>
      <div class="mb-50 text-center">
        @if (fiatTransaction?.getType() === 'deposit') {
          <a (click)="goToWallet()">
            {{ "go-to-wallet" | translate }}
          </a>
        }
      </div>
      @if (fiatTransaction?.getType() === 'deposit') {
        <div class="mb-50 text-center">
          <button (click)="tradeMore()" class="btn btn-primary btn-success-modal mod-middle" type="button">
            {{ "lets-buy-coins" | translate }}
          </button>
        </div>
      }
    </div>
    <div class="text-center">
      <button (click)="close()" class="btn btn-primary btn-success-modal" type="button">
        <strong>{{ "close" | translate }}</strong>
      </button>
    </div>
  </div>
</success-screen>
